import React from 'react';
import { AddCertificateCard, CertificateCard, Certificate } from './index';
import { useStyles } from '../styles';

interface CertificatesGridProps {
  certificates: Certificate[];
  isArchivedProject?: boolean;
  onAddCertificate: () => void;
  onEditCertificate: (certificateId: string) => void;
  onDeleteCertificate: (certificate: Certificate) => void;
}

const CertificatesGrid: React.FC<CertificatesGridProps> = ({
  certificates,
  isArchivedProject,
  onAddCertificate,
  onEditCertificate,
  onDeleteCertificate,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.mainContainer}>
      <div className={`${classes.grid} ${classes.gridMobile}`}>
        {!isArchivedProject && <AddCertificateCard onAddCertificate={onAddCertificate} />}
        {certificates
          .filter(cert => !cert.isDeleted)
          .map(certificate => (
            <CertificateCard
              key={certificate.id}
              certificate={certificate}
              disabled={isArchivedProject}
              onEdit={onEditCertificate}
              onDelete={onDeleteCertificate}
            />
          ))}
      </div>
    </div>
  );
};

export default CertificatesGrid;
